import { Helpers } from '../../helpers';
import { IPhaseStepType } from '../../interfaces/iphase-step-type';
import { DrillDesignFactor } from '../drill-design-factor';
import { DrillDurationLookup } from '../drill-duration-lookup';
import { Equation } from '../equation';
import { PhaseStepScheduleType } from '../phase-step-schedule-type';
import { ScheduleActivity } from '../schedule-activity';
import { StandardRatesOfPenetration } from '../standard-rates-of-penetration';

export class PhaseStepTypeBase {
  PhaseStepTypeId: number;
  Phase: string | null;
  Step: string | null;
  PhaseStepScheduleTypeId: number | null;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  DrillDesignFactors_PhaseStepType?: Array<DrillDesignFactor> | null;
  DrillDurationLookups_PhaseStepType?: Array<DrillDurationLookup> | null;
  Equations_PhaseStepType?: Array<Equation> | null;
  ScheduleActivities_PhaseStepType?: Array<ScheduleActivity> | null;
  StandardRatesOfPenetrations_PhaseStepType?: Array<StandardRatesOfPenetration> | null;
  PhaseStepScheduleType?: PhaseStepScheduleType;

  constructor(item?: IPhaseStepType) {
    if (item) {

      this.PhaseStepTypeId = item.PhaseStepTypeId;
      this.Phase = item.Phase;
      this.Step = item.Step;
      this.PhaseStepScheduleTypeId = item.PhaseStepScheduleTypeId;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.DrillDesignFactors_PhaseStepType = Helpers.createClassArray(DrillDesignFactor, item.DrillDesignFactors_PhaseStepType);
      this.DrillDurationLookups_PhaseStepType = Helpers.createClassArray(DrillDurationLookup, item.DrillDurationLookups_PhaseStepType);
      this.Equations_PhaseStepType = Helpers.createClassArray(Equation, item.Equations_PhaseStepType);
      this.ScheduleActivities_PhaseStepType = Helpers.createClassArray(ScheduleActivity, item.ScheduleActivities_PhaseStepType);
      this.StandardRatesOfPenetrations_PhaseStepType = Helpers.createClassArray(StandardRatesOfPenetration, item.StandardRatesOfPenetrations_PhaseStepType);
      this.PhaseStepScheduleType = new PhaseStepScheduleType(item.PhaseStepScheduleType);
    }
  }
}